module.exports = __webpack_public_path__ + "static/media/twitter.ad81e814.png";